import Vue from 'vue';

function findParentByTagName(element, tagName) {
	var parent = element;

	while (parent !== null && parent.tagName !== tagName.toUpperCase()) {
		parent = parent.parentNode;
	}

	return parent;
}

function handleAnchorClick(event) {
	event = event || window.event;

	const anchorDom = findParentByTagName(event.target || event.srcElement, 'A');

	if (anchorDom) {
		const href = anchorDom.getAttribute('href');
		try {
			const urlO = new URL(href);
			if (/\.nexon\.net$/.test(urlO.host)) {
				event.preventDefault();
				const arenaSid = Vue.cookie.get('arenaSid'); // vue-cookie library is used
				urlO.searchParams.set('arenaSid', arenaSid);
				const target = anchorDom.getAttribute('target');
				// console.log('An anchor was clicked!', urlO.href);
				if (target) window.open(urlO.href, target);
				else location.href = urlO.href;
			}
			// eslint-disable-next-line no-empty
		} catch {}
	}
}

document.addEventListener('click', handleAnchorClick);
